import React from 'react';
import { Box, BoxProps } from '@mui/material';

interface USAFlagIconProps extends Omit<BoxProps, 'component'> {
  size?: 'small' | 'medium' | 'large';
}

const USAFlagIcon: React.FC<USAFlagIconProps> = ({ size = 'medium', sx, ...props }) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return 16;
      case 'large':
        return 32;
      default:
        return 24;
    }
  };

  const iconSize = getSize();

  return (
    <Box
      component="img"
      src="/images/ui/american-flag-small.png"
      alt=""
      role="img"
      aria-hidden="true"
      sx={{
        width: iconSize,
        height: iconSize * (10 / 19),
        objectFit: 'contain',
        display: 'block',
        ...sx,
      }}
      {...props}
    />
  );
};

export default USAFlagIcon;
